const React = require('react');
const useFormCtx = require('./useFormCtx');

module.exports = (Component) => ({
 className,
 type,
 ...props
}) => {

  const {
    id,
    label,
    name,
    value,
    error,
    showError,
    isRequired,
    onChange,
    format,
    views,
    minDate,
    maxDate,
    disabled,
    disableFuture,
    ...rest
  } = useFormCtx(props);

  return (
    <Component
      className={className}
      {...rest}
      labelProps={{
        id,
        label,
        isRequired,
      }}
      inputProps={{
        id,
        name,
        type,
        onChange,
        value,
        minDate,
        maxDate,
        format,
        views,
        disabled,
        showError,
        disableFuture
      }}
      errorProps={{
        showError,
        error
      }}
    />
  )
}
